import { render } from "./LayerAbout.vue?vue&type=template&id=552d97a4&scoped=true"
import script from "./LayerAbout.vue?vue&type=script&lang=js"
export * from "./LayerAbout.vue?vue&type=script&lang=js"

import "./LayerAbout.vue?vue&type=style&index=0&id=552d97a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552d97a4"]])

export default __exports__